<li
    tabindex="5"
    class="p5">
    @if (hasPermission()) {
        <button
            type="button"
            class="btn btn-default nlr-icon-btn"
            id="alignToolBtn"
            [title]="getAlignTooltip()"
            (click)="align()"
            [disabled]="isDisabled()">
            <i class="nlrp-icon nlrp-icon-align-annotation"></i>
        </button>
    }
</li>

<li
    tabindex="5"
    class="p5">
    @if (hasPermission()) {
        <button
            type="button"
            class="btn btn-default nlr-icon-btn"
            id="flipToolBtn"
            [title]="getFlipTooltip()"
            (click)="flip()"
            [disabled]="isDisabled()">
            <i class="nlrp-icon nlrp-icon-flip-features"></i>
        </button>
    }
</li>
